import { StoryBlokRichText } from '@cinch-nx/data-storyblok'
import { RichTextStyles } from '@cinch-labs/design-system'
import cx from 'classnames'
import renderWithResolver from './rich-text-renderer/rich-text-renderer'
import styles from './rich-text.module.css'

interface RichTextProps {
  text: StoryBlokRichText
  className?: string
}

export const RichText = ({ text, className }: RichTextProps) => (
  <RichTextStyles className={cx(className, styles.headings, styles.container)}>
    {renderWithResolver(text)}
  </RichTextStyles>
)
